import { PagedSearch } from '../../../shared/model/index';
import { SerialSearchExpression } from '../../../shared/search-expression/serial-search-expression.model';
import { AgingPeriodEnum } from './aging-period.model';

/**
 * advanced search params for invoice selector
 */
export class InvoiceAdvancedSearch extends PagedSearch {
  public InvoiceInfoSearchExpressions: SerialSearchExpression[] = [];
  public InvoicePaymentSearchExpressions: SerialSearchExpression[] = [];
  public AgingPeriod: AgingPeriodEnum = AgingPeriodEnum.None;
  public RevenueItemNums: number[] = [];
  public InvoiceNums: number[] = [];
  public ExcludeInvoiceNums: number[] = [];
  public IgnoreProfiles: number[] = [];
  public PermitProfiles: number[] = [];
  public Guid: string;

  constructor(partialDto?: Partial<InvoiceAdvancedSearch>) {
    super();

    Object.assign(this, partialDto);
  }
}
